import React from "react";
import Button from "@mui/material/Button";
import PictureAsPdfSharpIcon from '@mui/icons-material/PictureAsPdfSharp';

export default class PrintFrame extends React.PureComponent {
  constructor(props) {
    super(props);
    this.containerEl = document.createElement("div");
  }

  render() {
    return (
      <React.Fragment>
        <Button
          variant="outlined"
          color="secondary"
          style={{
            height: "35px",
            marginTop: "5px",
            display: "inline-block",
          }}
          onClick={(e) => {e.preventDefault();this.printDocument()}}
        >
          <PictureAsPdfSharpIcon />
        </Button>
        <iframe
          title="print-dashboard-iframe"
          style={{ height: "0pt", width: "612pt", position: "absolute", visibility: 'hidden' }}
          ref={(el) => (this.iframe = el)}
        ></iframe>
      </React.Fragment>
    );
  }
  componentDidUpdate() {}

  printDocument() {
    this.iframe.contentDocument.body.innerHTML = "";
    this.iframe.contentDocument.body.appendChild(
      this.props.content().cloneNode(true)
    );
    this.updateHeights(this.iframe.contentDocument.body);

    this.iframe.contentWindow.print();
  }

  updateHeights(body) {
    let content = body.getElementsByClassName("presentation-dashboard")[0];
    
    content.getElementsByClassName("react-grid-layout")[0].style.width = "572pt";
    content.getElementsByClassName("react-grid-layout")[0].style.height = "";
    content.getElementsByClassName("react-grid-layout")[0].style.display = "flex";
    content.getElementsByClassName("react-grid-layout")[0].style.flexDirection = "column-reverse";
    
    for (let i=0; i < content.getElementsByClassName("react-grid-item").length; i++) {
      content.getElementsByClassName("react-grid-item")[i].style.width = "570pt";
      content.getElementsByClassName("react-grid-item")[i].style.removeProperty("height");
      content.getElementsByClassName("react-grid-item")[i].style.top = "";
      content.getElementsByClassName("react-grid-item")[i].style.left = "";
      content.getElementsByClassName("react-grid-item")[i].style.position = "";
      
      let div = content.getElementsByClassName("react-grid-item")[i];
      let subdiv = div.getElementsByTagName("div")[0];
      subdiv.getElementsByTagName("div")[0].style = "";
    }
    
    for (let i=0; i < content.getElementsByClassName("dc-chart-container").length; i++) {
      content.getElementsByClassName("dc-chart-container")[i].style.width = "100%";
      content.getElementsByClassName("dc-chart-container")[i].style.height = "auto";
      content.getElementsByClassName("dc-chart-container")[i].style.margin = "5pt 0 0 0";
      content.getElementsByClassName("dc-chart-container")[i].style.transform = "scale(0.50)";
      content.getElementsByClassName("dc-chart-container")[i].style.transformOrigin = "top left";
      // table.dc-chart-container {
      //   transform: scale(0.80) !important;
      //   transform-origin: top left !important;
      // important seems to do opposite in here when in print preview
    }
  }

  componentDidMount() {

    // mostly taken from here https://github.com/gregnb/react-to-print/blob/master/src/index.tsx#L270
    const headEls = document.querySelectorAll("style, link[rel='stylesheet']");
    for (let i = 0, headElsLen = headEls.length; i < headElsLen; ++i) {
      const node = headEls[i];
      if (node.tagName.toLowerCase() === "style") {
        // <style> nodes
        const newHeadEl = this.iframe.contentDocument.createElement(
          node.tagName
        );
        const sheet = node.sheet;
        if (sheet) {
          let styleCSS = "";
          // NOTE: for-of is not supported by IE
          try {
            // Accessing `sheet.cssRules` on cross-origin sheets can throw
            // security exceptions in some browsers, notably Firefox
            // https://github.com/gregnb/react-to-print/issues/429
            const cssLength = sheet.cssRules.length;
            for (let j = 0; j < cssLength; ++j) {
              if (typeof sheet.cssRules[j].cssText === "string") {
                styleCSS += `${sheet.cssRules[j].cssText}\r\n`;
              }
            }
          } catch (error) {
            // this.logMessages([`A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/gregnb/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross \`crossorigin\` attribute, and setting the \`Access-Control-Allow-Origin\` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.`, node], 'warning');
          }

          newHeadEl.setAttribute("id", `react-to-print-${i}`);
          // if (nonce) {
          //     newHeadEl.setAttribute("nonce", nonce);
          // }
          newHeadEl.appendChild(
            this.iframe.contentDocument.createTextNode(styleCSS)
          );
          this.iframe.contentDocument.head.appendChild(newHeadEl);
        }
      } else {
        // <link> nodes, and any others
        // Many browsers will do all sorts of weird things if they encounter an
        // empty `href` tag (which is invalid HTML). Some will attempt to load
        // the current page. Some will attempt to load the page"s parent
        // directory. These problems can cause `react-to-print` to stop without
        // any error being thrown. To avoid such problems we simply do not
        // attempt to load these links.
        if (node.getAttribute("href")) {
          const newHeadEl = this.iframe.contentDocument.createElement(
            node.tagName
          );

          // Manually re-create the node
          // TODO: document why cloning the node won't work? I don't recall
          // the reasoning behind why we do it this way
          // NOTE: node.attributes has NamedNodeMap type that is not an Array
          // and can be iterated only via direct [i] access
          for (let j = 0, attrLen = node.attributes.length; j < attrLen; ++j) {
            // eslint-disable-line max-len
            const attr = node.attributes[j];
            if (attr) {
              newHeadEl.setAttribute(attr.nodeName, attr.nodeValue || "");
            }
          }

          // newHeadEl.onload = markLoaded.bind(null, newHeadEl, true);
          // newHeadEl.onerror = markLoaded.bind(null, newHeadEl, false);
          // if (nonce) {
          // newHeadEl.setAttribute("nonce", nonce);
          // }
          this.iframe.contentDocument.head.appendChild(newHeadEl);
        } else {
          // this.logMessages(['"react-to-print" encountered a <link> tag with an empty "href" attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:', node], 'warning')
          // `true` because we"ve already shown a warning for this
          // markLoaded(node, true);
        }
      }
    }
    // this.iframe.contentDocument.body.appendChild(this.containerEl);
  }
}
